import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from '../../config'
import {
  ContainerDivs,
  Link
} from '../../components'

import Styles from './PlanScorecardSelfDirectedOption.css'


@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardSelfDirectedOption extends Component {
  static propTypes = {
    planData: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      // planData: props.planData,
      hasSelfDirectedOption: (
        props.planData.access_self_directed &&
        props.planData.access_self_directed.length>0
      ),
      hasAccessHeadline: 'This plan has a self-directed option that may ' +
      'offer access to sustainable funds.',
      hasNoAccessHeadline: 'This plan has no ' +
      'self-directed option.'
    }
  }

  render() {
    const { hasSelfDirectedOption, hasAccessHeadline,
            hasNoAccessHeadline } = this.state

    const iconSelfDirected = require( '../../../static/images/icon-self-directed.png' )

    //
    return (
      <div styleName={
        hasSelfDirectedOption ?
          'brokerage-wrap' :
          'no-brokerage-wrap'
        }
      >
        <ContainerDivs>
          <Row styleName='brokerage-inner'>
            <Col xs={12} sm={12}>
              <div styleName='brokerage-flex'>
                <div>
                  <div styleName='brokerage-flex-label'>
                    Self-directed option
                  </div>
                  <h3 styleName='brokerage-flex-text'>
                    {
                      hasSelfDirectedOption ?
                        hasAccessHeadline :
                        hasNoAccessHeadline
                    }
                  </h3>
                  <div styleName='brokerage-flex-sublede'>
                    {
                      hasSelfDirectedOption ?
                        (
                          <div>
                            <p>
                              A <Link
                                to={config.routes.faqs + '#is-offering-a-self-directed-option-brokerage-window-enough-'}
                                title='Is offering a self-directed option (brokerage window) enough?'
                                xstrong
                              >
                                self-directed option
                              </Link> (also called a "brokerage
                              window") can provide more access to sustainable
                              funds. But a self-directed option requires more
                              effort from plan participants, and could lead to
                              riskier investments. It's better for
                              retirement plans to offer sustainable
                              funds without making people use a self-directed
                              option - or even better, to make the default
                              investment sustainable.
                            </p>
                            <p>
                              If your plan
                              has a self-directed option,
                              you can use our <Link
                                to={config.routes.mutualFundsETFs}
                                title='Mutual funds and ETFs'
                                xstrong
                              >
                                database of mutual funds and ETFs
                              </Link> to find sustainable funds that meet
                              your investment needs.
                            </p>
                          </div>
                        ) :
                        (
                          <p>
                            A <Link
                              to={config.routes.faqs + '#is-offering-a-self-directed-option-brokerage-window-enough-'}
                              title='Is offering a self-directed option (brokerage window) enough?'
                            >
                              <span styleName='white-xstrong'>self-directed option</span>
                            </Link> (also called a "brokerage
                            window") can provide plans more access to
                            sustainable funds. Without one, plan participants
                            are restricted to the plan options approved by the
                            plan administrator, usually between 20 and 30
                            funds, and usually not including many (if any)
                            sustainable funds. We found no evidence
                            this plan includes a self-directed option.
                          </p>
                        )
                    }
                  </div>
                </div>
                {
                  hasSelfDirectedOption ?
                    <div styleName='brokerage-icon'>
                      <img
                        src={iconSelfDirected}
                        alt='This plan has a self-directed option that may offer access to sustainable funds.'
                      />
                    </div> :
                    null
                }
              </div>
            </Col>
          </Row>
        </ContainerDivs>
      </div>
    )
  }
}